module.exports = __webpack_public_path__ + "static/img/mp32.19627139.png";